export default __webpack_public_path__ + "static/media/nao-binario.a32384f3.svg";